export default __webpack_public_path__ + "static/media/nip_4.f7000a4a.jpg";